<template>
  <div id="chattingAPP">
    <chatZoneMenu :chatZoneArray="chatZoneArray" />
    <router-view />
  </div>
</template>

<script>
import store from './vuex/store'
import chatZoneMenu from './components/chat-zone-menu'

export default {
  store,
  name: 'chattingAPP',
  components: {
    'chatZoneMenu': chatZoneMenu
  },
  data: function () {
    let chatZoneArray = {
      'localhost': { 'zoneName': '스포츠', 'rel': 'localhost', 'userCount': 0, 'routeLink': '/localhost', 'routeName': 'openchatting-sport' },
      'lottery': { 'zoneName': '미니게임', 'rel': 'lottery', 'userCount': 0, 'routeLink': '/lottery', 'routeName': 'openchatting-lottery' }
      // 'racing': { 'zoneName': '미니게임', 'rel': 'racing', 'userCount': 0, 'routeLink': '/racing', 'routeName': 'openchatting-racing' },
      // 'fxgame': { 'zoneName': 'FX게임', 'rel': 'fxgame', 'userCount': 0, 'routeLink': '/fxgame', 'routeName': 'openchatting-fxgame' },
      // 'esport': { 'zoneName': '다리다리', 'rel': 'esports', 'userCount': 0, 'routeLink': '/esports', 'routeName': 'openchatting-legleg' },
      // 'game': { 'zoneName': '사다리', 'rel': 'game', 'userCount': 0, 'routeLink': '/game', 'routeName': 'openchatting-ladder' },
      // 'rooms': { 'zoneName': '방채팅', 'rel': 'lobby', 'userCount': 0, 'routeLink': '/lobby', 'routeName': 'chatroomlobby' }
      // 'fireworks': { 'zoneName': '불꽃놀이', 'rel': 'fireworks', 'userCount': 0, 'routeLink': '/fireworks', 'routeName': 'openchatting-fireworks' }
    }
    return {
      'chatZoneArray': chatZoneArray
    }
  },
  mounted() {
    const hostname = window.location.hostname;

    // List of domains that should use their own root for the icon URL
    const dynamicDomains = [
      'named.com',
      'xn--950bo4em5v.co',
      'named.net',
      'named2.net',
      'named2.kr'
    ];

    let rootDomain = 'nmd.co';
    for (const domain of dynamicDomains) {
      if (hostname.includes(domain)) {
        rootDomain = domain;
        break;
      }
    }

    let sportChatIconUrl = `https://image.${rootDomain}/portal/sp_chat_icons.png?v=1`;

    document.documentElement.style.setProperty('--sport-chat-icon', `url("${sportChatIconUrl}")`);
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

a {
  text-decoration: none;
}

input,
img,
button {
  vertical-align: top;
  margin: 0;
  box-sizing: border-box;
}

#chattingAPP {
  background-color: #ffffff;
  height: 100%;
  border: 1px solid #dee3eb;
  border-left: none;
  font-family: '굴림', Gulim, sans-serif;
  font-size: 11px;

  #popupWindowLayer {
    display: none;
    position: fixed;
    background: #ffffff;
    top: 50%;
    left: 50%;
    width: 300px;
    height: 200px;
    margin: -100px 0 0 -150px;
    font-size: 14px;
    border: 1px solid #ffffff;
    border-radius: 20px;

    #popupMessage {
      padding: 20px;
    }

    #chromeDownloadLinkButton {
      text-align: center;
      padding: 10px 0 0 0;
      width: 200px;
      height: 30px;
      margin: 0px 50px;
      background-color: #FF024F;
      color: #fff;
      font-weight: 600;
      border: 1px solid #FF024F;
      border-radius: 5px;
    }
  }

  #backgroundPlate {
    display: none;
    background-color: #000000;
    /* Good browsers */
    opacity: 0.3;
    /* IE 8 */
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=30)";
    /* IE 5-7 */
    filter: alpha(opacity=30);
    /* Netscape */
    -moz-opacity: 0.3;
    /* Safari 1.x */
    -khtml-opacity: 0.3;

    width: 100%;
    height: 100%;
  }

}
</style>



// WEBPACK FOOTER //
// App.vue?16b783a4